const CategoryPopCont2 = (props) => {
    return(
        <div className="tab_con tab_con2">
            <div className="tab_inner">
                <div className="blank_category">빈 메뉴 카테고리를 선택합니다.</div>
            </div>
        </div>
    );
};

export default CategoryPopCont2;